<template>
  <div>
    <h2 class="center welcomeText">Welcome To Project Geo</h2>
    <h4 class="center">Please Login to use Map</h4>
  </div>
</template>
<script>
export default {
  name: "HomeComponent",
};
</script>
<style lang="scss">
.welcomeText {
  padding-top: 3em;
}
.center {
  text-align: center;
  margin: 8px;
}
</style>
